import { NavLink } from 'react-router-dom';
import { FaHome, FaTasks, FaQuran, FaChartBar, FaUser } from 'react-icons/fa';
import DailyActions from '../daily/DailyActions';
import Logo from './Logo';
import useAuth from '../../hooks/useAuth';

const Sidebar = ({ isOpen, onClose }) => {
    const { user } = useAuth();
    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-logo">
                <Logo size="small" showText={false} />
            </div>

            <nav className="sidebar-nav">
                <ul>
                    <li>
                        <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')} onClick={onClose}>
                            <FaHome /> Tableau de bord
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/tasks" className={({ isActive }) => (isActive ? 'active' : '')} onClick={onClose}>
                            <FaTasks /> Tâches
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/quran" className={({ isActive }) => (isActive ? 'active' : '')} onClick={onClose}>
                            <FaQuran /> Coran
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/stats" className={({ isActive }) => (isActive ? 'active' : '')} onClick={onClose}>
                            <FaChartBar /> Statistiques
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')} onClick={onClose}>
                            <FaUser /> Profil
                        </NavLink>
                    </li>
                    {user && user.role === 'admin' && (
                        <li>
                            <NavLink to="/admin" className={({ isActive }) => (isActive ? 'active' : '')} onClick={onClose}>
                                <FaUser /> Admin
                            </NavLink>
                        </li>
                    )}
                </ul>
            </nav>

            <div className="sidebar-daily-actions">
                <DailyActions compact={true} />
            </div>
        </div>
    );
};

export default Sidebar;
